import React from 'react';
import AutoSizeTitle from '../../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../../components/individualInformHeader/individualInformHeader';
import ResumeRadarSelfcare360 from '../../../graphics/selfcare360/resumeRadarSelfcare360';
import { SELFCARE360_DIMENSION_THRESHOLDS } from '../../../components/selfcare360/selfcare360Scales';
import '../../../components/selfcare360/resumeSelfcare360.css';

const PageResumeSelfcare360_2 = ({ selectedEvaluation, totalResults, individualResult, pageNumber, orgLogo }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const totalsByKey = totalResults?.average_by_dimension || {};

    const dimensions = Object.entries(individualResult?.average_by_dimension || {})
        .filter(([key, _]) => !key.toLowerCase().includes('general'))
        .map(([key, value]) => ({
            key,
            title: value?.title,
            average: value?.average,
        }))
        .filter((d) => d.title);

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    <div className="selfcare360-resume-title">Comparativo en Seguridad</div>

                    <ResumeRadarSelfcare360
                        dimensions={dimensions}
                        totalsByKey={totalsByKey}
                        expectedMin={SELFCARE360_DIMENSION_THRESHOLDS.greenMin}
                    />
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResumeSelfcare360_2;
